import { TabPanel, Tabs } from 'components/utility/Tabs'
import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import PropertySettingTabGeneral from './General'
import PropertySettingTabPricing from './Pricing'
import PropertySettingTabProcessor from './Processor'

const tabsMapping = {
  general: PropertySettingTabGeneral,
  pricing: PropertySettingTabPricing,
  processors: PropertySettingTabProcessor,
}

const PropertySettingTabs = (props) => {
  const { tabs } = useSelector((state) => state.buildingQuestionnaireAdmin)
  const [activeIndex, setActiveIndex] = useState(0)
  const onChangeTab = useCallback((newIndex) => setActiveIndex(newIndex), [])

  return (
    <div className="property-setting-tabs">
      <Tabs activeIndex={activeIndex} setActiveIndex={onChangeTab}>
        {tabs.map((tab) => {
          const Component = tabsMapping[tab.tab]

          return (
            <TabPanel key={tab.tab} label={tab.label}>
              <div style={{ marginTop: '18px' }}>
                <Component {...props} />
              </div>
            </TabPanel>
          )
        })}
      </Tabs>
    </div>
  )
}
export default PropertySettingTabs
